var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107372605,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 11702,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M731.989333 170.666667C336 170.666667 156.330667 315.306667 97.322667 377.344a113.92 113.92 0 0 0-30.677334 68.010667L42.666667 734.634667a114.773333 114.773333 0 0 0 29.354666 86.698666c19.157333 20.821333 44.629333 32 71.978667 32h632.021333c43.136 0 81.962667-29.866667 96-73.344C981.973333 440.021333 981.333333 410.154667 981.333333 398.677333 981.333333 331.178667 793.002667 170.666667 731.989333 170.666667zM280.021333 360.021333h69.333334v283.989334H469.333333v57.344H279.978667z m249.301334 0h105.344c109.482667 0 109.354667 77.482667 109.354666 93.312 0 53.674667-36.522667 69.973333-44.032 73.344 8.661333 2.474667 48 13.994667 48 74.666667 0 33.152-10.837333 100.010667-106.666666 100.010667h-112zM597.333333 417.28v85.333333h36.010667c36.693333 0 41.344-27.648 41.344-41.344 0-43.306667-26.026667-43.946667-40.021333-43.946666z m0 136.021333v90.666667h43.989334c37.845333 0 38.656-37.674667 38.656-43.989333 0-14.506667-2.304-46.677333-35.968-46.677334z",
    fill: "#333",
    "p-id": 11703
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLb);
export default __webpack_public_path__ + "static/media/lb.f8696183459d71a389bc0b26948e0e3d.svg";
export { ForwardRef as ReactComponent };